/**
 * uuidService.js -- Generates UUIDs via the Django backend API.
 * Returns UUID v7 (time-ordered, RFC 9562) values.
 */

import { PYTHON_API_BASE_URL } from "../../../services/api/apiConstants";

/**
 * Fetches a single UUID v7 from the backend.
 * @returns {Promise<string>} UUID string
 */
export async function generateDeviceId() {
  const token = sessionStorage.getItem("accessToken");

  const headers = {
    Accept: "application/json",
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${PYTHON_API_BASE_URL}/generate-uuid/`, {
    method: "GET",
    headers,
  });

  if (!response.ok) {
    throw new Error(`UUID generation failed: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  return data.uuid;
}
